import React from "react";
import { Box, IconButton, Tooltip, Chip } from "@mui/material";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export const PanelZoomControls = ({ zoom, zoomIn, zoomOut, resetZoom, minZoom, maxZoom }) => {
  const percentage = Math.round(zoom * 100);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        backgroundColor: "rgba(245, 247, 250, 0.95)",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        px: 1,
        py: 0.25,
        backdropFilter: "blur(4px)",
      }}
    >
      <Tooltip title="Reducir tamaño (Mínimo 75%)">
        <span>
          <IconButton size="small" onClick={zoomOut} disabled={zoom <= minZoom} sx={{ p: 0.5 }}>
            <ZoomOutIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Porcentaje de escala actual">
        <Chip
          label={`${percentage}%`}
          size="small"
          color={percentage < 100 ? "primary" : "default"}
          variant={percentage < 100 ? "filled" : "outlined"}
          sx={{
            height: "20px",
            fontSize: "0.75rem",
            fontWeight: "bold",
            "& .MuiChip-label": { px: 0.8 },
          }}
        />
      </Tooltip>

      <Tooltip title="Aumentar tamaño (Máximo 100%)">
        <span>
          <IconButton size="small" onClick={zoomIn} disabled={zoom >= maxZoom} sx={{ p: 0.5 }}>
            <ZoomInIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      {zoom < maxZoom && (
        <Tooltip title="Restablecer al 100%">
          <IconButton size="small" onClick={resetZoom} sx={{ p: 0.5, color: "#666" }}>
            <RestartAltIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
